module.exports = __webpack_public_path__ + "img/bsocks.d8b360a4.jpg";